<i18n src="./resources/locales.json"></i18n>
<template>
  <v-dialog v-model="isConfirmationOpened" :width="dialogWidth" persistent>
    <v-card>
      <v-card-title class="sms-primary-area">
        <span class="headline">{{ this.confirmationTitle || $t('title') }}</span>
      </v-card-title>
      <v-card-text class="sms-confirmation-content">
        {{ this.confirmationText || $t('defaultConfirmationText') }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="decline">
          {{ $t('decline') }}
        </v-btn>
        <v-btn class="sms-primary-button" @click="accept">
          {{ $t('accept') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SmsConfirmationDialog',

  data() {
    return {
      isConfirmationOpened: false,
      confirmationData: null,
      confirmationText: null,

    };
  },

  props: {
    confirmationTitle: {
      type: String,
    },
    dialogWidth: {
      type: Number,
      default: 600
    },
  },

  methods: {
    open({ confirmationData, confirmationText, confirmationTitle }) {
      this.isConfirmationOpened = true;
      this.confirmationData = confirmationData;
      if (confirmationText) {
        this.confirmationText = confirmationText;
      }
      if (confirmationTitle) {
        this.confirmationTitle = confirmationTitle;
      }
    },

    accept() {
      this.isConfirmationOpened = false;
      this.$emit('confirm-action', this.confirmationData);
      this.confirmationData = null;
    },

    decline() {
      this.isConfirmationOpened = false;
      this.$emit('decline-action', this.confirmationData);
      this.confirmationData = null;
    },

    close() {
      this.isConfirmationOpened = false;
      this.confirmationData = null;
    }
  }
};
</script>

<style scoped>
.sms-confirmation-content {
  padding-top: 24px !important;
  font-size: 1rem;
}
</style>
